<template>
  <div>
    <!-- MODAL PROPOSTAS -->
    <div
      class="modal fade"
      id="visualizar-propostas"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      @click.self="cancelModal"
      @keydown.esc="cancelModal"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button id="close" type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="this.setListarProposta(false)">
                &times;
              </button>
              <h4>Visualizar propostas</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover" style="position: relative">
                    <thead>
                      <tr>
                        <th style="width: 15px !important">Seq</th>
                        <th style="width: 55% !important">Leilão</th>
                        <th style="width: 40% !important">Proposta</th>
                        <th style="width: 15px !important">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(proposta, index) in propostas" :key="proposta" style="cursor: pointer">
                        <td data-label="Seq">{{ index + 1 }}</td>
                        <!--
              <td data-label="Usuário">
                <label>Apelido:</label>

                <i class="fa-solid fa-circle" style="margin-right: 1px; margin-left: 3px" ></i>
                {{ proposta.apelido }}
                <br />

                <label>Nome:</label>
                {{ proposta.nome }}
                <br />

                <label>CPF:</label>
                {{ proposta.cpf }}
                <br />

                <label>Status usuário:</label>
                {{ proposta.user_status }}

                <div class="card" style="background-color: rgb(219, 181, 10) !important" v-if="proposta.pendencias.length">
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    <p v-for="(pendencia, index) in proposta.pendencias" :key="pendencia">
                      <div v-html="pendencia.conteudo"  style="margin: 0px 0px 0px 0px"></div>
                    </p>
                  </div>
                </div>
              </td>
              -->

                        <td data-label="Leilão/Lote">
                          <div>
                            <b>Leilão:&nbsp;</b>
                            <a :href="'/admin/leilao/' + proposta.leilao_id">{{ proposta.leilao_id }} - {{ proposta.leilao_titulo }}</a>
                          </div>
                          <div>
                            <b>Lote:&nbsp;</b>
                            <a :href="'/admin/leilao/' + proposta.lote_id + '/lotes/editar/' + proposta.lote_id">
                              {{ proposta.lote_id }} - {{ proposta.lote_titulo }}
                            </a>
                          </div>
                          <div>
                            <b>Praça:&nbsp;</b>
                            {{ proposta.praca }}
                          </div>
                          <div>
                            <b>Data leilão:&nbsp;</b>
                            {{ formatDate(proposta.data_leilao) }}
                          </div>
                        </td>

                        <td data-label="Proposta">
                          <div style="text-transform: uppercase">
                            <b>Tipo:&nbsp;</b>
                            {{ proposta.tipo }}
                          </div>
                          <div>
                            <b>Aberto:&nbsp;</b>
                            {{ convertTiny(proposta.aberto) }}
                          </div>
                          <div>
                            <b>Data envio:&nbsp;</b>
                            {{ formatDate(proposta.created_at) }}
                          </div>
                          <div>
                            <br />
                          </div>
                          <div v-if="proposta.deleted_at" style="color: red">
                            <b>Proposta revogada em:&nbsp;</b>
                            {{ formatDate(proposta.deleted_at) }}
                          </div>
                        </td>

                        <td>
                          <a
                            id="navbarDropdown"
                            class="nav-link"
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-pre
                          >
                            <i class="fa-solid fa-bars" style="color: gray"></i>
                          </a>

                          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                            <div class="dropdown-divider"></div>
                            <a v-if="!proposta.deleted_at" class="dropdown-item" @click="deletar(proposta)" style="cursor: pointer">
                              <i class="fa-solid fa-trash"></i>
                              &nbsp;&nbsp; Revogar
                            </a>

                            <div class="dropdown-divider"></div>
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              data-target="#visualizar-modal"
                              @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                              style="cursor: pointer"
                            >
                              <i class="fa-solid fa-search"></i>
                              &nbsp;&nbsp; Visualizar
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer clearfix">
                  <!-- TOTAIS  -->
                  <div style="font-size: 13px" class="float-left" aria-live="polite">
                    Exibindo do {{ inicio + 1 }} ao {{ inicio + propostas.length }}
                    <p>Total {{ total }}</p>
                  </div>

                  <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

                  <select
                    @change="alterarQtdPaginaProposta()"
                    class="float-left card-titlecustom-select rounded-0"
                    style="font-size: 12px"
                    v-model="qtd_por_pagina"
                  >
                    <option :value="1">1</option>
                    <option :value="2">2</option>
                    <option :value="7">7</option>
                    <option :value="15">15</option>
                    <option :value="25">25</option>
                  </select>

                  <!-- PAGINAÇÃO  -->
                  <ul class="pagination pagination-sm m-0 float-right">
                    <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

                    <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                      <a
                        :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                        class="page-link"
                        href="#"
                        @click="selecionarPagina(pagina)"
                      >
                        {{ pagina }}
                      </a>
                    </li>

                    <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
                  </ul>
                </div>
              </div>
              <div>
                <button class="btn btn-danger" data-dismiss="modal" @click="this.setListarProposta(false)">Fechar</button>

                <button hidden data-toggle="modal" data-target="#visualizar-propostas" id="abrir_modal_propostas" class="btn btn-danger">
                  Abrir modal
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL VISUALIZAR PROPOSTA -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="visualizar_proposta"
      @click.self="visualizar_proposta = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="visualizar_proposta = false">&times;</button>
              <h4>Proposta enviada</h4>
              <br />
              <div class="p-2">
                <proposta :proposta="proposta_selecionada" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["leilao", "setListarProposta", "lote_id"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      proposta_selecionada: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      propostas: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
      somente_pendentes: false,
      apelido: "",
      leilao_id: "",
      visualizar_proposta: "",
      filtro_proposta_status: "nao_revogadas",
    };
  },

  mounted() {
    console.log("Exibindo propostas");
    console.log(this.leilao);

    this.buscarPropostas();
  },

  methods: {
    cancelModal() {
      this.setListarProposta(false);
    },

    getFormatedText(texto) {
      if (texto && texto.length > 30) {
        return texto.substring(0, 30) + "...";
      } else {
        return texto;
      }
    },

    getClass(status) {
      if (status == "pendente") {
        return "table_todos_line";
      } else if (status == "liberado") {
        return "table_todos_line";
      } else if (status == "bloqueado") {
        return "table_todos_line";
      } else {
        return "";
      }
    },

    limparFiltros() {
      this.somente_pendentes = false;
      this.apelido = "";
      this.leilao_id = "";

      this.buscarPropostas();
    },

    getStyle(status) {
      let style = "cursor:pointer;";

      if (status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    getDataProximaPraca(proposta) {
      if (proposta.leilao_oculto || proposta.leilao_retirado || proposta.leilao_suspenso || proposta.leilao_encerrado) {
        return "";
      } else if (proposta.leilao_num_pracas >= 1 && proposta.leilao_1_realizado == 0) {
        return this.formatDate(proposta.leilao_1_data);
      } else if (proposta.leilao_num_pracas >= 2 && proposta.leilao_2_realizado == 0) {
        return this.formatDate(proposta.leilao_2_data);
      } else if (proposta.leilao_num_pracas >= 3 && proposta.leilao_3_realizado == 0) {
        return this.formatDate(proposta.leilao_3_data);
      } else if (proposta.leilao_num_pracas >= 4 && proposta.leilao_4_realizado == 0) {
        return this.formatDate(proposta.leilao_4_data);
      }
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = moment(new Date());
        let data = moment(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    getLinkProposta(proposta) {
      let url = process.env.MIX_VUE_APP_URL + "/proposta/" + proposta.hash;

      return url;
    },

    getUrlProposta(proposta) {
      let url = process.env.MIX_VUE_APP_URL + "/proposta/" + proposta.hash;

      if (url && url.length > 30) {
        return url.substring(0, 30) + "...";
      } else {
        return url;
      }
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(proposta) {
      this.proposta_selecionada = proposta;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarPropostas();
      }
    },

    buscarPropostas() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        desc: true,
        somente_pendentes: this.somente_pendentes,
        apelido: this.apelido,
        leilao_id: this.leilao.id,
        filtro_proposta_status: "todas",
      };

      if (this.lote_id) {
        data.lote_id = this.lote_id;
      }

      console.log(data);

      axios
        .post(`/admin/propostas/search`, data)
        .then((response) => {
          this.propostas = response.data.propostas;
          this.total = response.data.total;

          console.log("Propostas");
          console.log(this.propostas);

          document.getElementById("abrir_modal_propostas").click();

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarPropostas();
    },

    deletar(proposta) {
      if (proposta) {
        this.proposta_selecionada = proposta;
      }

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.proposta_selecionada.id,
            };

            console.log("Revogando");
            console.log(data);

            axios
              .post(`/admin/proposta/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Proposta revogada!");
                this.buscarPropostas();
                document.getElementById("close").click();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
